/* global axios */
import ApiClient from './ApiClient';

class DataAssistantAPI extends ApiClient {
  constructor() {
    super('data_assistant/conversations', { accountScoped: true });
  }

  updateMessage(conversationId, messageId, data) {
    return axios.patch(
      `${this.url}/${conversationId}/messages/${messageId}`,
      data
    );
  }

  ask(conversationId, question) {
    return axios.post(`${this.url}/${conversationId}/ask`, { question });
  }

  downloadMessageCsv(conversationId, messageId) {
    return axios.get(`${this.url}/${conversationId}/message_csv`, {
      params: { message_id: messageId },
      responseType: 'blob',
    });
  }
}

export default new DataAssistantAPI();
